export enum Role {
  FLEET_MANAGER = "fleet_manager",
  AGENT = "agent",
  DRIVER = "driver",
}
